import { Component, OnDestroy, OnInit } from '@angular/core';
import { LeftMenuService } from '../../store/services/left-menu.service';
import { ApiDataSource } from '../../datasources/api.datasrouce';
import { IAccount } from '../../store/models/account.model';
import { ETableColumnType, ITableColumn } from '../../store/models/table.model';
import { Subject } from 'rxjs';
import { SessionService } from '../../store/services/session.service';
import { takeUntil } from 'rxjs/operators';
import { IUserSessionData, UserType } from '../../store/models/user.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EmailStatusComponent } from '../list-accounts/email-status/email-status.component';
import { ButtonColor, ButtonSize } from '../../store/models/button.model';
import { ManagerRoleRendererComponent } from './manager-role-renderer/manager-role-renderer.component';
import { AccountService } from '../../store/services/account.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { ResetAccountPasswordComponent } from './reset-account-password/reset-account-password.component';
import { UserService } from '../../store/services/user.service';
import { init } from '../../store/actions/user.action';

@Component({
  selector: 'app-view-representatives',
  templateUrl: './view-representatives.component.html',
  styleUrls: ['./view-representatives.component.scss'],
})
export class ViewRepresentativesComponent implements OnInit, OnDestroy {
  dataSource: ApiDataSource<IAccount>;
  tableColumns: ITableColumn<IAccount>[] = [];
  sessionData: IUserSessionData;
  tableReady: boolean;

  private readonly destory$: Subject<boolean> = new Subject<boolean>();

  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'account_id',
    sortDir: 'desc',
    filters: {},
  };

  constructor(
    private readonly leftMenuService: LeftMenuService,
    private readonly sessionService: SessionService,
    private readonly http: HttpClient,
    private readonly accountService: AccountService,
    private readonly router: Router,
    private readonly store$: Store<IReducers>,
    private readonly userService: UserService
  ) {
    this.dataSource = new ApiDataSource<IAccount>(
      this.http,
      environment.apiUrl + '/v1/users'
    );
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destory$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.leftMenuService.expand('manage');
        this.tableColumns = [
          {
            id: 'name',
            title: 'Name',
            renderer: row => `${row.first_name} ${row.last_name}`,
          },
          {
            id: 'status',
            title: 'Status',
            type: ETableColumnType.COMPONENT,
            componentProperties: {
              component: EmailStatusComponent,
              mapData: {
                status: {
                  instance: 'column',
                  target: 'status',
                },
              },
            },
          },
          {
            id: 'email',
            title: 'Email',
          },
        ];
        if (this.sessionData.user_type !== UserType.MANAGER) {
          this.tableColumns = [
            ...this.tableColumns,
            {
              id: 'total_credits',
              title: 'Total Credits',
            },
            {
              id: 'balance_credits',
              title: 'Rem. Credits',
            },
          ];
        }
        this.tableColumns = [
          ...this.tableColumns,
          {
            id: 'use',
            title: 'Use',
            type: ETableColumnType.BUTTON,
            buttonProperties: {
              text: 'Use',
              color: ButtonColor.GREEN,
              style: 'outline',
              observeApi: true,
              onClick: (row: IAccount) => {
                this.accountService
                  .switchAccount(row.account_id)
                  .subscribe(response => {
                    localStorage.setItem('token', JSON.stringify(response));
                    this.store$.dispatch(init());
                    this.router.navigate(['/']);
                  });
              },
              size: ButtonSize.SMALL,
            },
          },
          {
            id: 'reset_password',
            title: 'Reset Password',
            type: ETableColumnType.BUTTON,
            buttonProperties: {
              text: 'Reset Pwd',
              color: ButtonColor.BLUE,
              style: 'outline',
              onClick: (element: IAccount) =>
                this.store$.dispatch(
                  openDialog({
                    dialogData: {
                      content: ResetAccountPasswordComponent,
                      title: 'Change Passcode',
                      canClose: true,
                      buttons: [
                        {
                          text: 'Update',
                          color: ButtonColor.BLUE,
                          onClick: dialog => {
                            if (
                              dialog.dialogForm.valid &&
                              dialog.dialogForm.get('password').value ===
                                dialog.dialogForm.get('password_repeat').value
                            ) {
                              this.userService
                                .resetPassword(
                                  element.account_id,
                                  dialog.dialogForm.get('password').value,
                                  dialog.dialogForm.get('password_repeat').value
                                )
                                .subscribe(result => {
                                  if (result && result.account_id) {
                                    this.store$.dispatch(
                                      openSnackbar({
                                        snackbarData: {
                                          data: {
                                            message:
                                              'Password was successfully reset!',
                                            type: 'success',
                                            button: {
                                              text: 'dismiss',
                                            },
                                          },
                                          verticalPosition: 'bottom',
                                        },
                                      })
                                    );
                                    dialog.closeDialog();
                                  }
                                });
                            }
                          },
                          size: ButtonSize.NORMAL,
                        },
                      ],
                    },
                  })
                ),
              size: ButtonSize.SMALL,
            },
          },
          {
            id: 'account_role',
            title: 'Role',
            type: ETableColumnType.COMPONENT,
            componentProperties: {
              component: ManagerRoleRendererComponent,
              mapData: {
                account: {
                  instance: 'column',
                },
              },
            },
          },
        ];
        this.tableReady = true;
      });
  }

  ngOnDestroy(): void {
    this.destory$.next(true);
  }
}
